const helpContents = {
    "/plan.html": {
        title: "일정 등록 방법",
        steps: [
            { icon: "✏️", text: "제목을 입력하세요." },
            { icon: "📍", text: "출발지/도착지를 터치하면 지도가 열립니다. 지도에서 위치를 선택하세요." },
            { icon: "🕐", text: "출발/도착 시간을 선택하세요." },
            { icon: "➕", text: "'일정 추가' 버튼을 누르면 등록됩니다." },
            { icon: "⇄", text: "가운데 교환 버튼으로 출발↔도착을 바꿀 수 있습니다." },
            { icon: "📋", text: "등록된 일정을 터치하면 수정할 수 있습니다." },
        ]
    },
    "/weather.html": {
        title: "날씨 예보 보는 방법",
        steps: [
            { icon: "📊", text: "등록된 일정별로 출발지/도착지의 날씨가 표시됩니다." },
            { icon: "👆", text: "날씨 아이콘이나 온도를 터치하면 상세 정보를 볼 수 있습니다." },
            { icon: "📝", text: "모든 날씨가 로드되면 하단에 '날씨 리포트' 버튼이 나타납니다." },
            { icon: "📄", text: "리포트에서 오늘 일정의 날씨를 한눈에 확인하세요." },
        ]
    },
    "/weatherinfo.html": {
        title: "날씨 리포트",
        steps: [
            { icon: "🌤️", text: "오늘 등록된 일정의 날씨를 종합한 리포트입니다." },
            { icon: "🌡️", text: "최저/최고 기온, 강수확률, 습도, 풍속 정보를 제공합니다." },
            { icon: "🌂", text: "비/눈 예보가 있으면 우산 챙기라는 안내가 표시됩니다." },
        ]
    },
    "/today.html": {
        title: "오늘 날씨 보는 방법",
        steps: [
            { icon: "📍", text: "현재 위치 또는 저장된 위치의 날씨를 볼 수 있습니다." },
            { icon: "⚙️", text: "설정 버튼을 눌러 자주 가는 위치를 추가/삭제하세요." },
            { icon: "⏰", text: "상단: 24시간 시간별 예보 (가로 스크롤)" },
            { icon: "📅", text: "하단: 7일 주간 예보" },
        ]
    },
    "/ys.html": {
        title: "여행 차량 배정",
        steps: [
            { icon: "👤", text: "이름을 입력하고 시작하세요." },
            { icon: "📍", text: "출발지와 귀환 도착지(집)를 지도에서 선택하세요." },
            { icon: "🕐", text: "출발 시간을 선택하세요." },
            { icon: "🚗", text: "차량 운행 시 토글을 켜고 탑승 가능 인원을 입력하세요." },
            { icon: "💾", text: "'저장' 후 '전체 현황'에서 참여자를 확인하세요." },
            { icon: "📊", text: "'차량 배정 실행'을 누르면 출발/귀환 배정 결과가 표시됩니다." },
            { icon: "🗺️", text: "각 차량의 '경로' 버튼으로 지도에서 경로를 확인할 수 있습니다." },
        ]
    },
    default: {
        title: "마이크로웨더 사용법",
        steps: [
            { icon: "📋", text: "'일정' 메뉴에서 출발지/도착지와 시간을 등록하세요." },
            { icon: "🌤️", text: "'예보' 메뉴에서 일정별 날씨를 확인하세요." },
            { icon: "📍", text: "'오늘' 메뉴에서 현재 위치의 24시간/주간 예보를 확인하세요." },
        ]
    }
};

export default helpContents;
